module.exports = __webpack_public_path__ + "static/RickMortyLab-d7eb00cb9e38cd16d58c26ce67b52040.jpg";